import { render, staticRenderFns } from "./right-rail.vue?vue&type=template&id=660c087e&"
import script from "./right-rail.vue?vue&type=script&lang=js&"
export * from "./right-rail.vue?vue&type=script&lang=js&"
import style0 from "./right-rail.vue?vue&type=style&index=0&id=660c087e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports